import { IAvailabilityHours, IDaySchedule } from "@leedpulse-monorepo/interfaces";
import { TDayOfWeek } from "@leedpulse-monorepo/types";

export const DAYS_OF_WEEK: TDayOfWeek[] = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const DAY_LABELS: Record<TDayOfWeek, string> = {
  monday: 'Lundi',
  tuesday: 'Mardi',
  wednesday: 'Mercredi',
  thursday: 'Jeudi',
  friday: 'Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
};

const DEFAULT_WEEKDAY: IDaySchedule = { enabled: true, slots: [{ start: '09:00', end: '18:00' }] };
const DEFAULT_WEEKEND: IDaySchedule = { enabled: false, slots: [] };

export const DEFAULT_AVAILABILITY_HOURS: IAvailabilityHours = {
  enabled: false,
  schedule: {
    monday: { ...DEFAULT_WEEKDAY },
    tuesday: { ...DEFAULT_WEEKDAY },
    wednesday: { ...DEFAULT_WEEKDAY },
    thursday: { ...DEFAULT_WEEKDAY },
    friday: { ...DEFAULT_WEEKDAY },
    saturday: { ...DEFAULT_WEEKEND },
    sunday: { ...DEFAULT_WEEKEND },
  },
};

export const formatSlotsSummary = (schedule: IDaySchedule): string => {
  if (!schedule.enabled || schedule.slots.length === 0) {
    return 'Fermé';
  }
  return schedule.slots.map((s) => `${s.start} - ${s.end}`).join(', ');
};
